import { Box, Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import {
  ExploreNewHomesBanner,
  MAP_DEFAULT_URL,
  MAP_HOVER_URL,
} from 'components/buyer/hub/ExploreNewHomesSection';

import { SECTION, SECTION_HEADING, SECTION_INNER } from './landingStyles';

const ExploreHomes = () => (
  <Box as="section" className={cn(SECTION, 'pb-12')}>
    <Col className={cn(SECTION_INNER, 'gap-10')}>
      <Text as="h2" className={cn(SECTION_HEADING, 'text-od-content-primary')}>
        Explore homes in your market
      </Text>
      <ExploreNewHomesBanner
        mapDefaultUrl={MAP_DEFAULT_URL}
        mapHoverUrl={MAP_HOVER_URL}
        label="Explore new homes"
        analyticsName="cosmos-make-offer-landing-explore-homes"
        className="aspect-[1207/397] h-auto rounded-[20px]"
      />
    </Col>
  </Box>
);

export default ExploreHomes;
